/**
 * Google Sign-In (web) client ID — public, safe to ship in the SPA.
 * Prefer REACT_APP_GOOGLE_CLIENT_ID in .env / CI so you can swap per environment.
 * Do NOT put OAuth client_secret in the frontend; use it only on a backend if needed.
 *
 * If the button iframe returns 403 or the console shows
 * "The given origin is not allowed for the given client ID", fix Google Cloud Console
 * (APIs & Services → Credentials → your OAuth 2.0 Web client):
 *
 *   Authorized JavaScript origins — add EVERY address you open this app from, exactly:
 *     http://localhost:3000
 *     http://127.0.0.1:3000
 *     https://preproddrugsync.tscerp.com
 *   If you use another port or LAN IP (e.g. http://192.168.1.5:3000), add that exact origin too.
 *   No path, no trailing slash (scheme + host + port only).
 *
 * Edge "Tracking Prevention" can block GSI storage — try Chrome for dev or allow localhost.
 */
export const GOOGLE_WEB_CLIENT_ID =
  process.env.REACT_APP_GOOGLE_CLIENT_ID ||
  "840592475611-p0qario2mppcvbtoicofinfk3cqo63hc.apps.googleusercontent.com";
